import React, { forwardRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import Toastify CSS
import style from './css/guide.module.css';
import careerguide from '../../assets/careerguide.pdf'


const Guide = forwardRef((props, ref) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ fullname: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { fullname, email, phone } = formData;
    if (!fullname || !email || !phone) {
      toast.error('Please fill in all fields.');
      return;
    }

    setLoading(true);

    const serviceID = 'service_wgxw3qs';
    const templateID = 'template_x7dogfp';
    const publicKey = 'lQuzkfQ0wi2Gohkde';

    const templateParams = {
      fullname,
      email,
      phone,
    };

    try {
      await emailjs.send(serviceID, templateID, templateParams, publicKey);
      toast.success('Please Wait! Download will start shortly.');

      // Trigger PDF download after a small delay (optional)
      setTimeout(() => {
        const link = document.createElement('a');
        link.href = careerguide;
        link.download = 'career_guide.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Reset form
        setFormData({ fullname: '', email: '', phone: '' });
        setShowForm(false);
      }, 2000); // 2 seconds delay so user can see the toast
    } catch (error) {
      console.error('EmailJS Error:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={style.guideSection} ref={ref}>
      <h2 className={style.title}>Download Our Free Guide</h2>
      <p className={style.text}>
        Brought to you by Aptech Computer Education Lekki Centre – A Trusted IT Training Institute with Global Certification Programs.
      </p>
      <button className={style.downloadBtn} onClick={() => setShowForm(true)}>
        Download Guide
      </button>

      {showForm && (
        <div className={style.modalOverlay}>
          <div className={style.modal}>
            <h3>Enter your details to download</h3>
            <form onSubmit={handleSubmit} className={style.form}>
              <input
                type="text"
                name="fullname"
                placeholder="Full Name"
                value={formData.fullname}
                onChange={handleInputChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
              <button type="submit" className={style.submitBtn} disabled={loading}>
                {loading ? 'Submitting...' : 'Submit & Download'}
              </button>
              <button
                type="button"
                className={style.cancelBtn}
                onClick={() => setShowForm(false)}
                disabled={loading}
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Toastify container */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </section>
  );
});

export default Guide;
